import { Component } from '@angular/core';

import { BaseListItemMenuComponent } from '../../../../../shared/base-classes/base-list-item-menu.component';
import { ListItemMenuContainerComponent } from '../../../../../shared/components/containers/list-item-menu-container/list-item-menu-container.component';
import { VehicleRoadWorthyCheckDeleteButtonComponent } from '../vehicle-road-worthy-check-delete-button/vehicle-road-worthy-check-delete-button.component';

@Component({
	selector: 'app-vehicle-road-worthy-checks-list-item-menu',
	templateUrl: 'vehicle-road-worthy-checks-list-item-menu.component.html',
	imports: [
		VehicleRoadWorthyCheckDeleteButtonComponent,
		ListItemMenuContainerComponent,
	],
})
export class VehicleRoadWorthyChecksListItemMenuComponent extends BaseListItemMenuComponent {}
